import * as PIXI from "pixi.js";
import SpriteGenerator from "../generators/SpriteGenerator";
import { convertSize } from "../utils";

export function loadGameoverScence({
  texture,
  stage,
  renderer,
  onTapGameover
}) {
  const gameoverScence = new PIXI.Container();
  gameoverScence.x = 0;
  gameoverScence.y = 0;

  gameoverScence.width = renderer.width;
  gameoverScence.height = renderer.height;

  const { width, height } = renderer.screen;
  const layout = {
    width: convertSize(275, window.innerWidth),
    height: convertSize(112, window.innerWidth)
  };

  const gameover = SpriteGenerator({
    ...layout,
    x: width / 2,
    y: height / 2 - convertSize(25, window.innerWidth),
    texture
  });
  gameover.anchor.set(0.5);

  gameover.interactive = true;

  gameover.on("tap", function() {
    onTapGameover();

    gameover.destroy();
    renderer.render(stage);
  });

  gameoverScence.addChild(gameover);

  stage.addChild(gameoverScence);

  return gameoverScence;
}
